import type { ReactNode } from 'react';
import { isValidElement } from 'react';

export const isValidReactNode = (value: unknown): value is ReactNode =>
    typeof value === 'string' || typeof value === 'number' || isValidElement(value);
